export const whatWentWrongNeedsInformation = (whatWentWrong) => [
  'part_defective', 'customer_mistake', 'other'
].includes(whatWentWrong);
